import { useTranslation } from "react-i18next";

export default function FooterColumn({ column }) {
  const { t } = useTranslation("landing");
  const { key, links } = column;

  return (
    <div>
      <h5 className="mb-5 text-[15px] font-extrabold text-ink">
        {t(`footer.${key}`)}
      </h5>
      <ul className="flex flex-col gap-1">
        {links.map((link) => (
          <li key={link.key}>
            <a
              href={link.href}
              className="inline-block py-1.5 text-[14px] text-ink-soft transition-all duration-200 hover:text-teal-2 rtl:hover:-translate-x-1.5 ltr:hover:translate-x-1.5 dark:hover:text-teal-3"
            >
              {t(`footer.${link.key}`)}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}